/**
 * GalleryInstanceContext
 *
 * 提供 React Context 让子组件（AllForGalleryList, AllForBigPic, AllForIndicator 等）
 * 能够访问当前 GalleryListWrapper 实例的独立 store，而不依赖全局 galleryStore。
 */
import React, { createContext, useContext } from "react";
import GalleryInstanceStore from "./GalleryInstanceStore";

const GalleryInstanceContext = createContext<GalleryInstanceStore | null>(null);

export const GalleryInstanceProvider = GalleryInstanceContext.Provider;

/**
 * 获取当前 GalleryListWrapper 实例的 GalleryInstanceStore。
 * 必须在 GalleryInstanceProvider 内部使用。
 */
export function useGalleryInstance(): GalleryInstanceStore {
  const store = useContext(GalleryInstanceContext);
  if (!store) {
    throw new Error(
      "useGalleryInstance must be used within a GalleryInstanceProvider"
    );
  }
  return store;
}

export default GalleryInstanceContext;
